import { Experiment, User } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useIsDraftPostsEnabled } from '@ms/yammer-hooks/dist/session';
import { useIsMtoCrossNetworkUser } from '@ms/yammer-hooks/dist/users';

import { UseUIFeatureCheck } from '../types';

export { useIsCurrentUser, useIsCurrentUserAdmin } from '@ms/yammer-hooks/dist/users';
export { useIsLeader } from '@ms/yammer-hooks/dist/userHeaders';

export { useCanCurrentUserAccessEnhancedUserProfile } from '@ms/yammer-hooks/dist/userProfile';

export const useIsBookmarkThreadEnabled: UseUIFeatureCheck = () =>
  useExperimentTreatmentWithoutReporting(Experiment.BookmarkThread) === 'enabled';

export const useIsUserAchievementsEnabled: UseUIFeatureCheck = () => {
  const isNetworkQuestionsEnabledInGA = useExperimentTreatmentWithoutReporting(Experiment.AnswersInVivaGA) === true;

  return isNetworkQuestionsEnabledInGA;
};

export const useIsScheduledPostEnabled: UseUIFeatureCheck = () => {
  const isScheduledPostFeatureEnabled = useExperimentTreatmentWithoutReporting(Experiment.ScheduledPosts) === true;
  const isDraftPostsEnabled = useIsDraftPostsEnabled();

  return isScheduledPostFeatureEnabled && isDraftPostsEnabled;
};

export const useIsMtoCrossNetworkUserProfile: UseUIFeatureCheck<[userId: User['id']]> = (userId) =>
  useIsMtoCrossNetworkUser(userId);
